

















import { Component, Vue } from "vue-property-decorator";
import { CurrentUser } from "@/store/authentication/types";
import { Action, Getter } from "vuex-class";
import i18n from "@/i18n";
import { FALLBACK_LOCALE } from "@/app.config";
const namespace: string = "authentication";

@Component
export default class ImpersonationStatus extends Vue {
    @Action("cancelImpersonationAction", { namespace }) cancelImpersonationAction: any;
    @Getter("getCurrentUser", { namespace }) currentUser!: CurrentUser;
    sideBarShrink = false as boolean;

    cancelImpersonation() {
        this.cancelImpersonationAction().then((response: string) => {
            this.setLocale();
            if (this.$route.path !== "/") {
                this.$router.push("/");
            }
        });
    }

    setLocale(): void {
        const languageCode: string = this.currentUser.cultureCode;
        i18n.locale = languageCode || FALLBACK_LOCALE;
    }
}
